import React, { useEffect, useState, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";

const CustomDateInput = forwardRef((props, ref) => {
  const [valDate, setValDate] = useState("");
  const [inputValue, setInputValue] = useState("");
  const changeHandler = (e) => {
    e.stopPropagation();
    const value = e.target.value;
    setInputValue(value);
    const dateRegex =
      /^(0?[1-9]|1[0-2])\/(0?[1-9]|[1-2][0-9]|3[0-1])\/(\d{2}|\d{4})$/;
    if (dateRegex.test(value)) {
      props.changeHandler(new Date(value), props.activity);
    } else {
      return;
    }
  };
  useEffect(() => {
    // const date = new Date(props.date).toLocaleString("en-029");
    const dateOnly = props.date.split(",")[0].trim();
    setValDate(dateOnly);
  }, []);

  return (
    <input
      key={props.activity._id}
      autoFocus
      className="date-input"
      type="text"
      value={inputValue}
      placeholder={props.date.split(",")[0].trim()}
      onChange={changeHandler}
    />
  );
});

export default CustomDateInput;
